/**
 * Main application entry point
 * Uses ES modules for modern browser support
 */

import { initApp } from './app.js';
import './styles/main.css';

// Initialize the application when DOM is ready
console.log('main.js loaded, readyState:', document.readyState);
if (document.readyState === 'loading') {
  console.log('Waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded fired');
    initApp();
  });
} else {
  console.log('DOM already ready, calling initApp');
  initApp();
}
